import * as React from 'react';
import { Dropdown, Option, OptionOnSelectData } from '@fluentui/react-components';

export interface TriStateBoolDropdownProps {
    value: boolean | null;
    onChange: (value: boolean | null) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
}

export const TriStateBoolDropdown: React.FC<TriStateBoolDropdownProps> = ({
    value,
    onChange,
    placeholder = "Choose a value",
    disabled = false,
    className
}) => {
    const displayValue = React.useMemo(() => {
        if (value === null) return "";
        return value ? "True" : "False";
    }, [value]);

    const selectedOptions = React.useMemo(() => {
        if (value === null) return [];
        return [value.toString()];
    }, [value]);

    const handleOptionSelect = React.useCallback((event: any, data: OptionOnSelectData) => {
        if (data.optionValue === "null") {
            onChange(null);
        } else {
            onChange(data.optionValue === "true");
        }
    }, [onChange]);

    return (
        <Dropdown
            placeholder={placeholder}
            value={displayValue}
            selectedOptions={selectedOptions}
            onOptionSelect={handleOptionSelect}
            disabled={disabled}
            className={className}
        >
            <Option key="true" value="true">True</Option>
            <Option key="false" value="false">False</Option>
            <Option key="null" value="null">(Not set)</Option>
        </Dropdown>
    );
};